"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("react-bootstrap/Button"));

var _Loading = _interopRequireDefault(require("../util/Loading"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "onClick",
    value: function onClick(e) {
      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          type = _this$props.type,
          loading = _this$props.loading,
          disabled = _this$props.disabled,
          id = _this$props.id,
          block = _this$props.block,
          href = _this$props.href,
          size = _this$props.size,
          wide = _this$props.wide,
          classes = _this$props.classes;
      return /*#__PURE__*/_react.default.createElement(_Button.default, {
        size: size,
        variant: type,
        disabled: disabled || loading ? true : false,
        className: (0, _classnames.default)(!show ? 'd-none' : undefined, wide ? 'btn-wide' : '', classes),
        onClick: this.onClick.bind(this),
        block: block,
        href: href,
        id: id
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          opacity: loading ? '0.3' : '1'
        }
      }, this.props.children), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(loading ? undefined : 'd-none'),
        style: {
          position: 'absolute',
          top: '0px'
        }
      }, /*#__PURE__*/_react.default.createElement(_Loading.default, null))));
    }
  }]);

  return Button;
}(_react.default.Component);

exports.default = Button;

_defineProperty(Button, "TYPE_DEFAULT", 'default');

_defineProperty(Button, "TYPE_PRIMARY", 'primary');

_defineProperty(Button, "TYPE_SECONDARY", 'secondary');

_defineProperty(Button, "propTypes", {
  size: _propTypes.default.string,
  show: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  type: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  block: _propTypes.default.bool,
  id: _propTypes.default.string,
  href: _propTypes.default.string,
  wide: _propTypes.default.bool,
  classes: _propTypes.default.string
});

_defineProperty(Button, "defaultProps", {
  show: true,
  type: Button.TYPE_PRIMARY,
  loading: false
});